import { render } from "./IngredientMeta.vue?vue&type=template&id=6b1298de"
import script from "./IngredientMeta.vue?vue&type=script&lang=js"
export * from "./IngredientMeta.vue?vue&type=script&lang=js"

import "./IngredientMeta.vue?vue&type=style&index=0&id=6b1298de&lang=css"

import exportComponent from "/var/www/staging.no-menu.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__